export const esDefaultLang = {
  buildings: 'Edificios',
  device_groups: 'Grupos de dispositivos',
  para_realizar_un_pedido:
    'Para realizar un pedido, seleciona primero el tipo de dispositivos y el grupo de dispositivos. Puedes indicar una fecha de recepción. A continuación, pulsa en cada dispositivo para añadir cantidades al transporte.',
  edit_group_device: 'Editar grupo de dispositivos',
  create_device_groups: 'Crear grupo de dispositivos',
  add_group_device: 'Añadir un grupo de dispositivos',
  device_group: 'Grupo de dispositivos',
  aprox_unit: 'Volumen aproximado',
  product_type: 'Tipo de producto'
};
